module.exports = __webpack_public_path__ + "static/media/crossingsImage2Mobile.1d92e6b0.png";